import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-home-integrations-section',
  templateUrl: './home-integrations-section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class HomeIntegrationsSectionComponent {}

